const PassWord = () => import(/* webpackChunkName: "index" */ './password/Index');

export default {
  routes: [
    {
      path: '/task/password',
      name: 'task_password',
      component: PassWord
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/task/router.js